<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">W<span class="smallcaps">ITH A</span></h1>
<h1 class="titlea_j">R<span class="smallcaps1">OYAL</span> E<span class="smallcaps1">NGINEERS</span> F<span class="smallcaps1">IELD</span> C<span class="smallcaps1">OMPANY</span></h1>
<h1 class="titlea"><span class="smallcaps">IN</span> F<span class="smallcaps">RANCE &amp;</span> I<span class="smallcaps">TALY</span></h1>
<p class="sub-title">A<span class="smallcaps1">PRIL</span> 1915 <span class="smallcaps1">TO THE</span> A<span class="smallcaps1">RMISTICE</span></p>
<p class="author">V. F. EBERLE</p>
<div class="img_container_j">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?ead7c9e0